module.exports = __webpack_public_path__ + "21075447815b40c0060a892c0cd5c9b6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/11_A#2.mp3
// module id = 110
// module chunks = 0